/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * DiamondHalfIcon
 */
export default class DiamondHalfIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M15.776 4c1.028 0 1.922.583 2.647 1.255l.153.145 3.503 3.693a3 3 0 01-.147 3.78l-.132.141-7.68 7.68-.036-.036-.054.12-.094.084-.097.08a3 3 0 01-3.818-.114l-.143-.135-7.68-7.68A3 3 0 011.81 9.25l.111-.158L5.476 5.4c.377-.406.733-.772 1.197-1.012.42-.216.882-.347 1.362-.38L8.275 4h7.5zm0 2h-3.777L12 19.572a.999.999 0 00.5-.134l.112-.075.094-.083 7.68-7.68.081-.092a1 1 0 00.085-1.102l-.073-.113L16.976 6.6l-.1-.12a1.5 1.5 0 00-.944-.472L15.776 6z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

